import { Drone } from 'lucide-react'

export function FooterSection() {
  return (
    <footer
      style={{
        padding: '24px 24px 40px',
        textAlign: 'center',
        borderTop: '1px solid #E9E5DC',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          marginBottom: 8,
        }}
      >
        <div
          style={{
            width: 24, height: 24,
            background: '#1A5C2E',
            borderRadius: 6,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <Drone size={13} color="#fff" strokeWidth={2} />
        </div>
        <span
          style={{
            fontFamily: 'var(--font-bricolage)',
            fontWeight: 800,
            fontSize: 14,
            color: '#0A1A10',
          }}
        >
          DroneOps
        </span>
      </div>
      <p style={{ fontSize: 11, color: '#A09D96' }}>
        © {new Date().getFullYear()} DroneOps. Todos os direitos reservados.
      </p>
    </footer>
  )
}
